import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import About from '@/pages/home/components/About';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://grainn-office.com';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'ProfilePage',
      '@id': `${siteUrl}/about#webpage`,
      url: `${siteUrl}/about`,
      name: '大阪 経営コンサルタント 後藤慎吾 プロフィール｜GRAINN 代表',
      description: 'GRAINN代表・後藤慎吾のプロフィール。大阪を拠点に経営コンサルティング・WEBサイト制作・SNS運用代行を提供。これまでの経歴と想いをご紹介します。',
      inLanguage: 'ja',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` },
          { '@type': 'ListItem', position: 2, name: 'プロフィール', item: `${siteUrl}/about` },
        ],
      },
      mainEntity: { '@id': `${siteUrl}/#person` },
    },
    {
      '@type': 'Person',
      '@id': `${siteUrl}/#person`,
      name: '後藤慎吾',
      jobTitle: '代表',
      url: `${siteUrl}/about`,
      worksFor: {
        '@type': 'Organization',
        name: 'GRAINN',
        url: `${siteUrl}/`,
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: '大阪市',
        addressRegion: '大阪府',
        addressCountry: 'JP',
      },
      email: 'goto_sn@grain-n.com',
      telephone: '080-5353-0610',
    },
  ],
};

export default function AboutPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="min-h-screen">
      <title>大阪 経営コンサルタント 後藤慎吾 プロフィール｜GRAINN 代表</title>
      <meta name="description" content="GRAINN代表・後藤慎吾のプロフィール。大阪を拠点に経営コンサルティング・WEBサイト制作・SNS運用代行を提供。これまでの経歴と想いをご紹介します。" />
      <link rel="canonical" href={`${siteUrl}/about`} />
      <JsonLd data={aboutJsonLd} id="about" />
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-44 pb-24 overflow-hidden bg-[#1C2B22]">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20Japanese%20creative%20designer%20workspace%20calm%20minimal%20green%20plant%20desk%20natural%20light%20warm%20bokeh%20elegant%20Osaka%20studio%20environment&width=1920&height=600&seq=about-hero-bg&orientation=landscape"
            alt="プロフィール"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1C2B22]/80 to-[#1C2B22]" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
          <p className="text-[#C9A878] text-xs tracking-[0.4em] mb-5 uppercase">/ About</p>
          <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight leading-tight mb-6">
            プロフィール
          </h1>
          <div className="w-16 h-px bg-[#C9A878]/60 mb-6" />
          <p className="text-white/60 text-lg max-w-xl leading-relaxed">
            <span translate="no">GRAINN</span> 代表のこれまでの歩みと想いをご紹介します。
          </p>
          <div className="flex items-center gap-2 mt-8 text-xs text-white/30">
            <Link to="/" className="hover:text-white/60 transition-colors">ホーム</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/60">プロフィール</span>
          </div>
        </div>
      </section>

      <About />

      <section className="py-20 bg-[#F8F5EF]">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1C2B22] mb-5 tracking-tight">
            一緒に成長していきましょう
          </h2>
          <p className="text-[#666] mb-8 text-base leading-relaxed">
            あなたのビジネスの課題、ぜひ聞かせてください。
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#2E5540] text-white px-10 py-4 rounded-full text-sm tracking-widest hover:bg-[#1C3A2A] transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-send-line" />
            お問い合わせはこちら
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
